import React from 'react';
import FormSetting from '../../layout/FormSetting';
import TextArea from '../../forms/TextArea';
import { QuestRoute } from '../../api/QuestRoutes';
import HamQuest from '../../api/HamQuestGiver';

const AirPay = ({ ...props }) => {

    return (
        <FormSetting
            label='Settings'
            getInputs={QuestRoute.airPay.settings}
            onSubmit={e => HamQuest.put(QuestRoute.airPay.settings, { ...e })}
            editable
        >
            <TextArea
                label='Details'
                name='details'
                required
            />
        </FormSetting>
    );
}

export default AirPay;